// components/GlobalAlert.js
import { Snackbar, Alert } from "@mui/material"
import useAlertStore from "store/alert"

const GlobalAlert = () => {
  const { isOpen, message, severity, hideAlert } = useAlertStore()

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return
    }
    hideAlert()
  }

  return (
    <Snackbar
      open={isOpen}
      autoHideDuration={3000}
      onClose={handleClose}
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
    >
      <Alert onClose={handleClose} severity={severity} variant="filled" sx={{ width: "100%" }}>
        {message}
      </Alert>
    </Snackbar>
  )
}

export default GlobalAlert
